import { defaultStyles, TooltipWithBounds } from "@visx/tooltip";
import { clsx } from "clsx";

import { ALL_METRICS } from "common/constants";
import { formatTimestamp, getMonthName } from "common/helpers/utils";
import type { Metrics } from "common/types";

export default function Tooltip({
  left,
  top,
  selectedMetric,
  data,
}: {
  left: number;
  top: number;
  selectedMetric: keyof Metrics;
  data: Metrics & { timestamp: number };
}) {
  const { label, className, icon: Icon } = ALL_METRICS[selectedMetric];
  const date = new Date(data.timestamp);

  return (
    <TooltipWithBounds
      key={Math.random()}
      left={left}
      top={top}
      style={{ ...defaultStyles, boxShadow: "none", padding: 0, lineHeight: 0 }}
    >
      <div className="flex min-w-36 flex-col gap-y-1 rounded-2xl px-3.5 py-2 text-black-950 shadow-md">
        <span className="text-xs">
          {`${date.getDate()} ${getMonthName(
            date.getMonth(),
          )} ${date.getFullYear()}`}{" "}
          {formatTimestamp(date.getTime())}
        </span>
        <div className="flex items-center gap-x-1">
          <Icon className={clsx("size-4", className.icon)} />
          <span className="text-xs-bold">{label}</span>
          <span className="ml-auto text-xs-bold">{data[selectedMetric]}</span>
        </div>
      </div>
    </TooltipWithBounds>
  );
}
